module.exports = __webpack_public_path__ + "static/img/组 2840.ea05bf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/images/组 2840.png
// module id = gg/4
// module chunks = 0